import { render, staticRenderFns } from "./caja-abierta.vue?vue&type=template&id=bc77ee58"
import script from "./caja-abierta.vue?vue&type=script&lang=js"
export * from "./caja-abierta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports